import styled from "styled-components";

export const Centered = styled.div`
  margin: 0 auto;
  max-width: 50rem;
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;
